import React from "react";
import { Control } from "react-hook-form";
import { Box } from "@mui/material";
import { ControlledRangePicker, TextField } from "../../../components";
import { CreateAbsenceInput } from "../../../API";

const TEST_ID = "time-off";

type FormValues = CreateAbsenceInput;

type Props = {
  maxAvailable: number;
  maxDate: Date;
  minDate: Date;
  minEndDate?: Date;
  pickerDays: Interval;
  control: Control<FormValues>;
  handleDateChange: (date: Date | null, key: "startDate" | "endDate") => void;
};

export const TimeOffDates = ({
  maxAvailable,
  maxDate,
  minDate,
  pickerDays,
  minEndDate,
  control,
  handleDateChange,
}: Props) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        md: "repeat(3, 1fr)",
      },
      alignItems: "start",
      gap: 2,
    }}
  >
    <ControlledRangePicker
      control={control}
      name="startDate"
      label="Start Date"
      views={["month", "day"]}
      onChange={async (date) => {
        await handleDateChange(date, "startDate");
      }}
      pickerDays={pickerDays}
      disablePast
      minDate={minDate}
      maxDate={maxDate}
      data-testid={`${TEST_ID}-startDate-picker`}
    />
    <ControlledRangePicker
      control={control}
      name="endDate"
      label="End Date"
      views={["month", "day"]}
      onChange={async (date) => {
        await handleDateChange(date, "endDate");
      }}
      pickerDays={pickerDays}
      minDate={minEndDate}
      maxDate={maxDate}
      disablePast
      data-testid={`${TEST_ID}-endDate-picker`}
    />
    <TextField
      control={control}
      name="amount"
      label="Amount"
      type="number"
      helperText=" "
      inputProps={{
        min: 0.5,
        step: 0.5,
        max: maxAvailable,
      }}
      data-testid={`${TEST_ID}-amount`}
    />
  </Box>
);
